/*
$(function () {
    $(document).on('click', '[js-treats-filter]', function (e) {
        var $this = $(this),
            val = $this.attr('data-filter-value');
        $('[js-treats]').toggleClass($this.data('filter-value'));

        if (sessionStorage.getItem(val) == 'active') {
            sessionStorage.setItem(val, 'not_active');
            $this.addClass('button_choice_active');
        } else {
            sessionStorage.setItem(val, 'active');
            $this.removeClass('button_choice_active');
        }
    });
    $('[js-treats-filter]').each(function () {
        var $this = $(this),
            val = $this.attr('data-filter-value');
        if (!sessionStorage.getItem(val)) {
            sessionStorage.setItem(val, 'active')
        }
        if (sessionStorage.getItem(val) == 'active') {
            $('[js-treats]').removeClass($this.data('filter-value'));
        } else {
            $('[js-treats]').addClass($this.data('filter-value'));
        }
    });
});*/
